export const defaultAiSearchConfig = {
    mainImage: {
        height: '50vh',
        minHeight: '200px',
        aspectRatio: 0.775,
        borderRadius: 0,
        maxHeight: 250,
        objectFit: 'contain',
    },
    thumbnails: {
        width: 76,
        height: 76,
        borderRadius: 8,
        gap: 8,
        selectedBorderWidth: 2,
        hoverBorderWidth: 2,
    },
    variantPhotoSwatches: {
        enabled: true,
        size: 50,
        gap: 8,
    },
    detailsButton: {
        padding: '12px 16px',
        borderRadius: 8,
        fontSize: '0.875rem',
    },
    typography: {
        titleFontSize: '1.1rem',
        priceFontSize: '1rem',
        errorFontSize: '0.75rem',
        cardTitleVariant: 'h6',
        panelTitleVariant: 'h5',
        cardTitleMaxLines: 2,
        panelTitleMaxLines: undefined,
    },
    description: {
        cardMaxLength: 75,
        panelMaxLength: 200,
        showSeeMore: true,
    },
    container: {
        padding: 16,
        gap: 16,
    },
    personalization: {
        enabled: false,
        personalizeButtonText: 'Click to Personalize',
        addToCartWithoutPersonalizationText: 'Add to Cart without Personalization',
    },
};
// Default values for Dual Mode Card Config
export const defaultDualModeCardConfig = {
    maxHeight: 300,
    showTitle: true,
    showDescription: false,
    showPrice: true,
    showAddToCartButton: false,
    showVariantSelection: false,
    elementOrder: ['productName', 'pricing'],
    priceBelowTitle: false,
    orientation: 'vertical',
    productCardVariant: 'minimal',
};
// Default values for Top Section Config
export const defaultTopSectionConfig = {
    maxHeight: 400,
    seeMoreLabel: 'See more results',
    seeLessLabel: 'See less',
};
// Helper function to merge admin config with defaults
export const resolveAiSearchConfig = (adminConfig) => {
    if (!adminConfig)
        return defaultAiSearchConfig;
    return {
        mainImage: { ...defaultAiSearchConfig.mainImage, ...adminConfig.mainImage },
        thumbnails: { ...defaultAiSearchConfig.thumbnails, ...adminConfig.thumbnails },
        variantPhotoSwatches: {
            ...defaultAiSearchConfig.variantPhotoSwatches,
            ...adminConfig.variantPhotoSwatches,
        },
        detailsButton: { ...defaultAiSearchConfig.detailsButton, ...adminConfig.detailsButton },
        typography: { ...defaultAiSearchConfig.typography, ...adminConfig.typography },
        description: { ...defaultAiSearchConfig.description, ...adminConfig.description },
        container: { ...defaultAiSearchConfig.container, ...adminConfig.container },
        personalization: { ...defaultAiSearchConfig.personalization, ...adminConfig.personalization },
        layout: adminConfig.layout,
        dualModeCardConfig: adminConfig.dualModeCardConfig
            ? { ...defaultDualModeCardConfig, ...adminConfig.dualModeCardConfig }
            : undefined,
        topSection: adminConfig.topSection
            ? { ...defaultTopSectionConfig, ...adminConfig.topSection }
            : undefined,
    };
};
//# sourceMappingURL=aiSearchConfig.js.map